import React, { PureComponent } from "react";

import { noop } from "lodash";

import {
  Container,
  ContainerHeader,
  ContainerTitle
} from "./styled-components";
import TracksMask from "../../_static/Masks/tracks";
import EmptyStateMessages from "../../_molecule/EmptyStateMessages";

export default class TracksAZ extends PureComponent {
  static defaultProps = {
    device: "mobile",
    templateTitle: "Tracks AZ",
    children: null,
    isLoading: true,
    hasError: false,
    onClearFilters: noop,
    hasActiveFilters: false,
    emptyMessages: {}
  };

  onClearFilters = () => {
    this.props.onClearFilters();
  };

  renderMessageType = () => {
    if (this.props.hasError) {
      return "error";
    }
    if (
      this.props.children &&
      this.props.children.length === 0 &&
      !this.props.hasActiveFilters
    ) {
      return "noraces";
    }
    return "info";
  };

  render() {
    const { isLoading, templateTitle, children, device } = this.props;
    return isLoading ? (
      <TracksMask />
    ) : (
      <Container data-qa-label="tracksAZContainer">
        <ContainerHeader
          data-qa-label="tracksAZHeader"
          isDesktop={device === "desktop"}
        >
          <ContainerTitle data-qa-label="tracksAZTitle">
            {templateTitle}
          </ContainerTitle>
        </ContainerHeader>
        {!!children && children.length > 0 ? (
          children
        ) : (
          <EmptyStateMessages
            messageType={this.renderMessageType()}
            onClearFilters={this.onClearFilters}
            emptyMessages={this.props.emptyMessages}
          />
        )}
      </Container>
    );
  }
}
